import { connect } from 'react-redux';

import UnsubscribeAddressForm from '../components/UnsubscribeAddressForm';
import { unsubscribeAddressRequest } from '../actions';
import { makeCancelable } from 'apps/account/utils';

const mapDispatchToProps = dispatch => ({
  onSubmit: address => {
    return makeCancelable(dispatch(unsubscribeAddressRequest(address)));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(UnsubscribeAddressForm);
